import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { Button, Container, Grid, Item, Segment } from 'semantic-ui-react';
import Formsy from 'formsy-react';
import styles from '../Event.scss';
import createStyles from './EventCreate.scss';
import MobileHeader from '../../App/MobileHeader';
import ContactFields from '../Show/ContactFields';
import {
  Analytics,
  AvailabilityChecker,
  Dthc,
  GlobalNotifications,
  Intent
} from '../../Modules';
import withAuth from '../../App/Authenticate';
import { FloatingLabelInput as Input, TextArea } from '../../Elements';
import { withRouter } from 'found';
import nullifyEmptyStrings from '../../../lib/utils/nullifyEmptyStrings';
import DateUtils from '../../../lib/utils/date';
import ReferralSource from '../Show/ReferralSource';
import EventSegmentShow from '../EventSegment/EventSegmentShow';
import EventSegmentMobile from '../EventSegment/EventSegmentMobile';
import EventSegmentDesktop from '../EventSegment/EventSegmentDesktop';
import { commitMutation, graphql } from 'react-relay';

Formsy.addValidationRule(
  'requireIfExists',
  (values, value, otherField) =>
    (values[otherField] ? values[otherField] !== '' && value !== '' : true)
);

Formsy.addValidationRule('requireIfAnyExist', (values, value) => {
  let valueExists = false;
  for (const key of Object.keys(values)) {
    if (values[key] !== null && values[key] !== '') {
      valueExists = true;
    }
  }
  return valueExists ? value && valueExists : true;
});

const CreateEventComponent = class CreateEvent extends React.Component {
  static propTypes = {
    viewer: PropTypes.object.isRequired,
    router: PropTypes.object.isRequired,
    relay: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      availabilityView: 'date',
      selectedDay: new Date(),
      submissionAttempts: 0,
      event: {
        title: '',
        booking_status: 'INITIAL',
        referral_source: '',
        notes: '',
        visibility: 'SHOW',
        contacts: [
          {
            node: {
              first_name: '',
              last_name: '',
              user_contact_emails: { edges: [] },
              user_contact_phones: { edges: [] },
              user_contact_addresses: { edges: [] }
            },
            role: ''
          }
        ],
        user_event_segments: []
      },
      cachedEventSegments: [],
      editingNewEventSegment: false,
      newEventSegment: {
        id: this.generateKey(),
        all_day: true,
        title: '',
        start_at: '',
        end_at: '',
        time_zone: this.props.viewer.s_time_zone,
        location: '',
        room: '',
        notes: ''
      },
      submitting: false
    };
    this.toggleAvailabilityView = this.toggleAvailabilityView.bind(this);
    this.updateSelectedDay = this.updateSelectedDay.bind(this);
    this.eventChangeHandler = this.eventChangeHandler.bind(this);
    this.contactChangeHandler = this.contactChangeHandler.bind(this);
    this.createEvent = this.createEvent.bind(this);
    this.addEventSegment = this.addEventSegment.bind(this);
    this.eventSegmentChangeHandler = this.eventSegmentChangeHandler.bind(this);
    this.generateKey = this.generateKey.bind(this);
    this.resetAddEventSegment = this.resetAddEventSegment.bind(this);
    this.resetEditEventSegment = this.resetEditEventSegment.bind(this);
    this.saveEventSegment = this.saveEventSegment.bind(this);
    this.newEventSegmentChangeHandler = this.newEventSegmentChangeHandler.bind(
      this
    );
    this.createEventSegment = this.createEventSegment.bind(this);
    this.closeNewEventSegmentEditor = this.closeNewEventSegmentEditor.bind(
      this
    );
    this.deleteEventSegment = this.deleteEventSegment.bind(this);
    this.referralChangeHandler = this.referralChangeHandler.bind(this);
    this.deleteUserContactEmail = this.deleteUserContactEmail.bind(this);
    this.deleteUserContactPhone = this.deleteUserContactPhone.bind(this);
    this.deleteUserContactAddress = this.deleteUserContactAddress.bind(this);
  }

  toggleAvailabilityView() {
    this.setState({
      availabilityView: this.state.availabilityView === 'date' ? 'time' : 'date'
    });
    return false;
  }

  updateSelectedDay(date) {
    this.setState({ selectedDay: date });
  }

  addEventSegment(e) {
    e.preventDefault();
    const obj = _.cloneDeep(this.state);
    if (!this.state.newEventSegment) {
      obj.newEventSegment = {
        id: this.generateKey(),
        all_day: true,
        title: '',
        start_at: '',
        end_at: '',
        time_zone: this.props.viewer.s_time_zone,
        location: '',
        room: '',
        notes: ''
      };
    }
    obj.editingNewEventSegment = true;
    this.setState({ ...obj });
  }

  closeNewEventSegmentEditor() {
    const obj = _.cloneDeep(this.state);
    obj.editingNewEventSegment = false;
    this.setState({ ...obj });
  }

  createEventSegment(index, successCb) {
    const obj = _.cloneDeep(this.state);
    const eventSegment = _.cloneDeep(this.state.newEventSegment);
    eventSegment.title = eventSegment.title
      ? eventSegment.title
      : '(Untitled Agenda Item)';
    obj.event.user_event_segments.push(eventSegment);
    obj.cachedEventSegments = _.cloneDeep(obj.event.user_event_segments);
    obj.newEventSegment = undefined;
    this.setState({ ...obj }, successCb);
  }

  deleteEventSegment(idx) {
    const obj = _.cloneDeep(this.state);
    obj.event.user_event_segments.splice(idx, 1);
    obj.cachedEventSegments = _.cloneDeep(obj.event.user_event_segments);
    this.setState({ ...obj });
  }

  eventChangeHandler(e) {
    const { name, value } = e.target;
    const newValue = {};
    newValue[name] = value;
    this.setState({ event: Object.assign(this.state.event, newValue) });
  }

  referralChangeHandler(e, data) {
    const obj = _.cloneDeep(this.state);
    obj.event.referral_source = data.value;
    this.setState({ ...obj });
  }

  contactChangeHandler(contact) {
    const obj = this.state;
    obj.event.contacts[0] = contact;
    this.setState(obj);
  }

  eventSegmentChangeHandler(eventSegment, idx) {
    const obj = _.cloneDeep(this.state);
    obj.cachedEventSegments[idx] = eventSegment;
    this.setState({ ...obj });
  }

  newEventSegmentChangeHandler(eventSegment) {
    const obj = _.cloneDeep(this.state);
    obj.newEventSegment = eventSegment;
    this.setState({ ...obj });
  }

  saveEventSegment(idx, successCb) {
    const obj = _.cloneDeep(this.state);
    const eventSegment = _.cloneDeep(obj.cachedEventSegments[idx]);
    eventSegment.title = eventSegment.title
      ? eventSegment.title
      : '(Untitled Agenda Item)';
    obj.event.user_event_segments[idx] = eventSegment;
    this.setState({ ...obj }, successCb);
  }

  resetAddEventSegment() {
    const obj = _.cloneDeep(this.state);
    obj.newEventSegment = undefined;
    this.setState({ ...obj });
  }

  resetEditEventSegment(idx) {
    const obj = _.cloneDeep(this.state);
    obj.cachedEventSegments[idx] = _.cloneDeep(
      obj.event.user_event_segments[idx]
    );
    this.setState({ ...obj });
  }

  deleteUserContactEmail(contactIdx, emailIdx) {
    const obj = _.cloneDeep(this.state);
    obj.event.contacts[contactIdx].node.user_contact_emails.edges.splice(
      emailIdx,
      1
    );
    this.setState(obj);
  }

  deleteUserContactPhone(contactIdx, phoneIdx) {
    const obj = _.cloneDeep(this.state);
    obj.event.contacts[contactIdx].node.user_contact_phones.edges.splice(
      phoneIdx,
      1
    );
    this.setState(obj);
  }

  deleteUserContactAddress(contactIdx, addressIdx) {
    const obj = _.cloneDeep(this.state);
    obj.event.contacts[contactIdx].node.user_contact_addresses.edges.splice(
      addressIdx,
      1
    );
    this.setState(obj);
  }

  createEvent(e) {
    e.preventDefault();
    this.setState({
      submissionAttempts: this.state.submissionAttempts + 1,
      submitting: true
    });
    const onError = () => {
      this.setState({ submitting: false });
      GlobalNotifications.show({
        message: 'Unable to create event',
        intent: Intent.DANGER
      });
    };
    const onCompleted = response => {
      this.props.router.push(`/events/${response.createEventForm.event.id}`);
      Analytics.trackEvent('created-event', {
        event_id: atob(response.createEventForm.event.id).match(/(\d+)/)[0]
      });
    };

    const mutation = graphql`
      mutation CreateEvent_CreateEventFormMutation(
        $input: CreateEventFormInput!
      ) {
        createEventForm(input: $input) {
          event {
            id
          }
        }
      }
    `;

    const environment = this.props.relay.environment;

    const event = nullifyEmptyStrings(_.cloneDeep(this.state.event));
    event.title = event.title ? event.title : '(Untitled Event)';
    event.user_event_segments = event.user_event_segments.map(segment => {
      const modifiedSegment = DateUtils.omitTimeZoneWithoutTimes(segment);
      delete modifiedSegment.all_day;
      delete modifiedSegment.id;
      return modifiedSegment;
    });

    if (
      !(
        event.contacts[0].node.first_name ||
        event.contacts[0].node.last_name ||
        event.contacts[0].node.user_contact_emails.edges.length !== 0 ||
        event.contacts[0].node.user_contact_phones.edges.length !== 0 ||
        event.contacts[0].node.user_contact_addresses.edges.length !== 0 ||
        event.contacts[0].role
      )
    ) {
      delete event.contacts;
    } else {
      const { first_name, last_name } = event.contacts[0].node;
      const phones = event.contacts[0].node.user_contact_phones.edges.map(
        userContactPhone => {
          const number = userContactPhone.node.number;
          const reformattedNumber = number ? number.replace(/\D/g, '') : null;
          return {
            label: userContactPhone.node.label,
            number: reformattedNumber === '' ? null : reformattedNumber
          };
        }
      );
      const emails = event.contacts[0].node.user_contact_emails.edges.map(
        userContactEmail => ({
          label: userContactEmail.node.label,
          address: userContactEmail.node.address
        })
      );
      const addresses = event.contacts[0].node.user_contact_addresses.edges.map(
        userContactAddress => ({
          label: userContactAddress.node.label,
          line1: userContactAddress.node.line1,
          line2: userContactAddress.node.line2,
          city: userContactAddress.node.city,
          province: userContactAddress.node.province,
          postal_code: userContactAddress.node.postal_code,
          country: userContactAddress.node.country
        })
      );
      event.contacts = [
        {
          first_name,
          last_name,
          phones,
          emails,
          addresses,
          role: event.contacts[0].role
        }
      ];
    }
    commitMutation(environment, {
      mutation,
      variables: {
        input: {
          ...event,
          user_id: this.props.viewer.id
        }
      },
      onCompleted,
      onError
    });
  }

  generateKey() {
    return `${Math.random().toString(36)}00000000000000000`.slice(2, 16 + 2);
  }

  render() {
    const { event } = this.state;
    const { router, viewer } = this.props;
    const submitted = this.state.submissionAttempts > 0;
    return (
      <div>
        <MobileHeader router={router} viewer={viewer}>
          <div className='menu'>
            <Item as='a' onClick={router.go.bind(null, -1)}>
              Cancel
            </Item>
          </div>
          <div className='right menu'>
            <AvailabilityChecker viewer={viewer} mobile />
            <Item
              as='a'
              onClick={this.state.submitting ? () => {} : this.createEvent}
            >
              {!this.state.submitting && 'Save'}
              {this.state.submitting && 'Saving...'}
            </Item>
          </div>
        </MobileHeader>
        <Container>
          <Segment style={{ marginTop: '2em' }}>
            <div>
              <Grid stackable padded>
                <Grid.Row>
                  <Grid.Column width={11} floated='left'>
                    <Formsy.Form>
                      <Input
                        autoFocus
                        placeholder='(Untitled Event)'
                        name='title'
                        value={event.title}
                        onChange={this.eventChangeHandler}
                        fluid
                        submitted={submitted}
                        autoHeight
                        inputRef={e => {
                          const element = e;
                          if (element) {
                            element.className = styles.title;
                          }
                        }}
                      />
                    </Formsy.Form>
                  </Grid.Column>
                  <Grid.Column
                    width={5}
                    floated='right'
                    textAlign='right'
                    only='computer'
                  >
                    <a
                      className={createStyles.cancel}
                      onClick={router.go.bind(null, -1)}
                    >
                      Cancel
                    </a>
                    <Button
                      onClick={this.createEvent}
                      disabled={this.state.submitting}
                      primary
                      content={
                        this.state.submitting ? 'Saving...' : 'Save Event'
                      }
                    />
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row />
                <Grid.Row columns='equal'>
                  <Grid.Column>
                    <h3>Notes</h3>
                    <Formsy.Form className={`ui form field ${styles.notepad}`}>
                      <TextArea
                        name='notes'
                        rows={18}
                        value={event.notes}
                        onChange={this.eventChangeHandler}
                        submitted={submitted}
                      />
                    </Formsy.Form>
                  </Grid.Column>
                  <Grid.Column>
                    <h3>Contact Information</h3>
                    <div style={{ paddingLeft: '1em' }}>
                      <ContactFields
                        localContact={this.state.event.contacts[0]}
                        onChange={this.contactChangeHandler}
                        submissionAttempts={this.state.submissionAttempts}
                        hideActions
                        index={0}
                        isNew
                        reset={() => {}}
                        deleteUserContactEmail={this.deleteUserContactEmail}
                        deleteUserContactPhone={this.deleteUserContactPhone}
                        deleteUserContactAddress={this.deleteUserContactAddress}
                      />
                      <div className={styles.verticalSpacing} />
                      <Formsy.Form>
                        <ReferralSource
                          onChange={this.referralChangeHandler}
                          value={event.referral_source}
                          pastReferralSources={
                            viewer.past_referral_sources
                          }
                          label='Referral Source'
                        />
                      </Formsy.Form>
                    </div>
                  </Grid.Column>
                  <Grid.Column>
                    <h3>Event Schedule</h3>
                    <div className={styles.verticalSpacing}>
                      {event.user_event_segments.length === 0 &&
                        !this.state.editingNewEventSegment &&
                        <div style={{ padding: '2em 0' }}>
                          <h4>This event has no agenda items</h4>
                          <br />
                          <Button
                            className='basic'
                            onClick={this.addEventSegment}
                          >
                            + Add Time and Place
                          </Button>
                        </div>}
                      {event.user_event_segments.map((eventSegment, idx) =>
                        <div className={styles.verticalSpacing} key={idx}>
                          <Dthc
                            eventSegment={eventSegment}
                            localEventSegment={
                              this.state.cachedEventSegments[idx]
                            }
                            onChange={segment => {
                              this.eventSegmentChangeHandler(segment, idx);
                            }}
                            commitUpdate={this.saveEventSegment}
                            desktop={EventSegmentDesktop}
                            mobile={EventSegmentMobile}
                            index={idx}
                            viewer={viewer}
                            delete={this.deleteEventSegment}
                            reset={this.resetEditEventSegment}
                            submissionAttempts={this.state.submissionAttempts}
                          >
                            <EventSegmentShow
                              eventSegment={eventSegment}
                              compact
                            />
                          </Dthc>
                        </div>
                      )}
                      {this.state.newEventSegment &&
                        this.state.editingNewEventSegment &&
                        <div className={styles.verticalSpacing}>
                          <Dthc
                            eventSegment={this.state.newEventSegment}
                            localEventSegment={this.state.newEventSegment}
                            onChange={segment => {
                              this.newEventSegmentChangeHandler(segment);
                            }}
                            commitUpdate={this.createEventSegment}
                            desktop={EventSegmentDesktop}
                            mobile={EventSegmentMobile}
                            delete={this.resetAddEventSegment}
                            reset={this.resetAddEventSegment}
                            initiallyOpen
                            isNew
                            viewer={viewer}
                            disableOnClickOutside={
                              event.user_event_segments.length === 0
                            }
                            closeEditor={this.closeNewEventSegmentEditor}
                            editorOpen={this.state.editingNewEventSegment}
                            submissionAttempts={this.state.submissionAttempts}
                          >
                            <EventSegmentShow
                              eventSegment={this.state.newEventSegment}
                            />
                          </Dthc>
                        </div>}
                    </div>
                    {event.user_event_segments.length > 0 &&
                      <div className={styles.verticalSpacing}>
                        <Button
                          className='basic'
                          onClick={this.addEventSegment}
                        >
                          + Add Time and Place
                        </Button>
                      </div>}
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </div>
          </Segment>
        </Container>
      </div>
    );
  }
};

export default withRouter(withAuth(CreateEventComponent));



// WEBPACK FOOTER //
// ./webpack/components/Event/Create/index.js